import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenuBar } from './NavMenuBar';
import { AppInstallBanner } from './AppInstallBanner';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
      <div>
        <NavMenuBar />
        <AppInstallBanner />
        <Container className="mainContainer">
          {this.props.children}
        </Container>
      </div>
    );
  }
}
